<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">گزارش فروش تکی</h5>
        <div style="flex: 1"></div>
        <ExcelDownload
          :url="
            `/admin/reports/single-products-new?start_date=${filterDate.startDate}&end_date=${filterDate.endDate}`
          "
        />
      </div>
      <div class="row px-4 not-in-print">
        <div class="row col-12">
          <b-form-group class="col-4">
            <multiselect
              placeholder="انتخاب انبار"
              v-model="selectedStore"
              open-direction="bottom"
              :options="stores"
              label="label"
              track-by="id"
              :searchable="true"
              :close-on-select="true"
              :show-labels="false"
              :disabled="disabled"
            >
              <template slot="noOptions"> موردی یافت نشد </template>
              <template slot="noResult"> موردی یافت نشد </template>
            </multiselect>
          </b-form-group>
          <DatePickerRange class="col-md-6" v-model="filterDate" />
        </div>
        <b-button
          class="col-md-2"
          variant="primary"
          @click="doFilter"
          :disabled="disabled"
          >فیلترسازی</b-button
        >
      </div>
      <div id="print" class="p-4">
        <!-- <div class="print-only">
                    <h4>فروشگاه ویکو</h4>
                </div>
                <br>
                <div class="d-flex mb-3 mr-2-print">
                    <span class="ml-1 font-bold">گزارش فروش صندوق دار</span>
                    <div v-if="filterDate.startDate">
                        <span>از</span>
                        <span class="font-weight-bold mx-1">تاریخ</span><span> {{ filterDate.startDate | persianDate }}
                        </span>
                    </div>
                    <div class="mr-3" v-if="filterDate.endDate">
                        <span>تا</span>
                        <span class="font-weight-bold mx-1">تاریخ</span><span> {{ filterDate.endDate | persianDate }}
                        </span>
                    </div>
                </div> -->
        <b-table
          v-if="reports"
          bordered
          :items="reports"
          striped
          :fields="fields"
          responsive
        >
          <template v-slot:cell(invoice_number)="data">
            <a
              :href="`/admin/shop/orders/${data.item.invoice_number}`"
              class="btn btn-primary"
              target="_blank"
              rel="noopener noreferrer"
              >{{ data.item.invoice_number }}</a
            >
          </template>
          <template v-slot:cell(date)="data">
            {{ data.item.date | persianDate }}
          </template>
          <template v-slot:cell(card_by_card_amount)="data">
            {{ data.item.card_by_card_amount | price }}
          </template>
          <template v-slot:cell(cash_amount)="data">
            {{ data.item.cash_amount | price }}
          </template>
          <template v-slot:cell(discount)="data">
            {{ data.item.discount | price }}
          </template>
          <template v-slot:cell(remainder)="data">
            {{ data.item.remainder | price }}
          </template>
          <template v-slot:cell(sell_price)="data">
            {{ data.item.sell_price | price }}
          </template>
          <template v-slot:cell(refund_price)="data">
            {{ data.item.refund_price | price }}
          </template>
          <template v-slot:cell(pos_price)="data">
            {{ data.item.pos_price | price }}
          </template>
          <template v-slot:cell(description)="data">
            <button
              class="btn btn-sm btn-icon btn-info text-dark"
              @click="openModal(data.item.invoice_number)"
              type="button"
            >
              مشاهده
            </button>
          </template>
          <template #bottom-row="data">
            <b-td colspan="6">جمع کل:</b-td>
            <b-td>
              {{ totals.card_by_card_amount | price }}
            </b-td>
            <b-td>
              {{ totals.cash_amount | price }}
            </b-td>
            <b-td>
              {{ totals.total_discount | price }}
            </b-td>
            <b-td>
              {{ totals.pos_price | price }}
            </b-td>
            <b-td>
              {{ totals.remainder | price }}
            </b-td>
            <b-td>
              {{ totals.sell | price }}
            </b-td>
            <b-td>
              {{ totals.refund | price }}
            </b-td>
            <b-td>
              *
            </b-td>
          </template>
        </b-table>
        <div v-if="!reports" class="alert alert-primary">در حال بارگزاری</div>
      </div>
    </div>

    <div class="modal fade" id="showModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content modal-content-demo">
          <div class="modal-header">
            <p class="modal-title font-weight-bold">توضیحات آیتم</p>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            <div>
              <b>توضیحات:</b>
              <p class="mr-2">{{ orderDescription }}</p>
            </div>
            <div class="modal-footer justify-content-center">
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                بستن
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import {
  BTable,
  BFormGroup,
  BFormInput,
  BButton,
  BTd,
  BFormCheckbox,
} from "bootstrap-vue";
import configProvider from "@@/core/configProvider";
import reportMixin from "@@/core/mixins/reportMixin";
import DatePickerRange from "@@/core/components/shared/DatePickerRange/DatePickerRange";
import ExcelDownload from "@@/core/components/excelDownload/ExcelDownload.vue";

function Filter() {
  this.search = "";
}
Filter.prototype.set = function(filters) {
  Object.entries(filters).forEach(([index, value]) => {
    this[index] = value;
  });
};

export default {
  name: "SinglePurchaseNew",
  components: {
    BTable,
    ExcelDownload,
    BFormGroup,
    BFormInput,
    BButton,
    BTd,
    DatePickerRange,
    BFormCheckbox,
  },
  configProvider,
  data() {
    return {
      disabled: false,
      fields: [
        {
          key: "row_number",
          label: "ردیف",
        },
        {
          key: "invoice_number",
          label: "شماره فاکتور",
        },
        {
          key: "product_title",
          label: "کالا",
        },
        {
          key: "pos_label",
          label: "دستگاه پوز",
        },
        {
          key: "quantity",
          label: "تعداد",
        },
        {
          key: "date",
          label: "تاریخ",
        },
        {
          key: "card_by_card_amount",
          label: "کارت به کارت(تومان)",
        },
        {
          key: "cash_amount",
          label: "نقدی(تومان)",
        },
        {
          key: "discount",
          label: "تخفیف(تومان)",
        },
        {
          key: "pos_price",
          label: "از پوز(تومان)",
        },
        {
          key: "remainder",
          label: "مبلغ باقی مانده(تومان)",
        },
        {
          key: "sell_price",
          label: "جمع فروش(تومان)",
        },
        {
          key: "refund_price",
          label: "جمع مرجوعی(تومان)",
        },
        {
          key: "description",
          label: "توضیحات",
        },
      ],
      page: 1,
      reports: null,
      totals: null,
      selectedStore: null,
      orderDescription: "",
      stores: [],
      filterDate: {
        endDate: "",
        startDate: "",
      },
      filter: new Filter(),
      appliedFilter: new Filter(),
      disabledRest: true,
    };
  },
  mixins: [reportMixin],
  mounted() {
    this.loadStores();
  },
  methods: {
    resetFilter() {
      this.disabledRest = true;
      this.loadData();
    },
    doFilter() {
      this.loadData();
    },
    changePage(page = 1) {
      this.previousPage = this.page;
      this.page = page;
      this.loadData();
    },
    async loadStores() {
      try {
        const response = await this.$axios.get("admin/stores");
        this.stores = response.data.data.stores;
        this.disabled = false;
      } catch (e) {
        this.$root.notify(e);
      }
    },
    openModal(invoice_number) {
      this.orderDescription = this.reports.find(
        (report) => report.invoice_number === invoice_number,
      ).description;
      $("#showModal").modal("show");
    },
    async loadData() {
      try {
        this.appliedFilter.set(this.filter);
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/reports/single-purchase-new",
          {
            params: {
              from_date: this.filterDate.startDate,
              to_date: this.filterDate.endDate,
              store_id: this.selectedStore ? this.selectedStore.id : "",
            },
          },
        );
        this.reports = response.data.data.reports;
        this.totals = response.data.data.totals;
        console.log(this.reports, "this.reports");
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
      }
    },
  },
};
</script>
